import("./bootstrap").then(({ mount }) => {
    const localRoot = document.getElementById("developer-api-mfe-ui");

    mount({
        mountPoint: localRoot as HTMLElement,
        routingStrategy: "browser"
    });
});

export { };
